import { LookupValue } from "../models/lookups/lookup.models";

export class LookupUtilities {

    public static matchLookupByIdRecursively(values: LookupValue[], value: number): LookupValue {
        if (values && values.length > 0) {
            for (let i = 0; i < values.length; i++) {
                if (values[i].id === value) {
                    return values[i];
                } else if (values[i].children) {
                    const test = this.matchLookupByIdRecursively(values[i].children, value);
                    if (test != null) {
                        return test;
                    }
                }
            }
        }
        return null;
    }
}